import Button from "./button/button"
import('./statistics.css')

export default function Statistics(opts){
    let container = opts.container
    let chart_name = opts.chart_name
    let available_options = ['max', 'min', 'average', 'last', 'diff']
    BaseConstructor.call(this)
    let elements = {}
    this.generate = () =>{
        elements.container = this.createElement('div')
        elements.buttons_container = this.createElement('div', 'statistics-options-container')
        $(elements.container).append(elements.buttons_container)
        available_options.forEach(option=>{
            console.log(option);
            let _button = new Button({option_name:option, chart_name:chart_name})
            $(elements.buttons_container).append(_button.getElement())
        })
        $(container).append(elements.container)
    }
}

Statistics.prototype = Object.create(BaseConstructor.prototype)